<template>
  <v-menu :close-on-content-click="false" min-width="250" offset-y>
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" class="mx-1" x-small>
        {{ $t('owlview.filters') }}
        <v-icon small> mdi-menu-down </v-icon>
      </v-btn>
    </template>
    <v-card class="card-wrap">
      <v-card class="pa-1 pt-3 elevation-0">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-text-field v-model="jobStep" type="text" :label="$t('dv.label.job.step')" :placeholder="this.$t('dv.hint.job.step')"
          class="text-full-width" outlined dense hide-details clearable />
      </v-card>
      <v-card class="pa-1 pb-3 elevation-0">
        <!-- <v-select>에 속성 solo가 지정되면 label이 표시되지 않는다. 주의할 것. -->
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-select v-model="selectedEvent" :items="events" :label="$t('dv.label.after.event')"
          outlined dense hide-details
          :menu-props="{ offsetY: true }" :style="{ width: '300px' }" />
      </v-card>
    </v-card>
  </v-menu>
</template>
<script>
import { api } from '@/api/common/instances';

export default {
  props: {
    systemId: String,
  },
  data() {
    return {
      jobStep: '',
      selectedEvent: '',
      events: [],
    };
  },
  watch: {
    systemId(value) {
      this.fetchEventList(value);
    },
    jobStep(value) {
      this.$emit('job-step', value);
    },
    selectedEvent(value) {
      this.$emit('selected-event', value);
    },
  },
  methods: {
    async fetchEventList(sstmId) {
      const { data } = await api.get(`/prefer/sap-event`, { params: { sstmId: sstmId } });
      this.events = data.map(e => e.eventid);
      this.events.splice(0, 0, '');
    },
  },
  created() {
    this.fetchEventList(this.systemId);
  },
};
</script>
<style lang="scss" scoped>
.text-full-width {
  width: auto;
  margin-bottom: 3px;
}
</style>
